import { Link } from 'react-router-dom';
// import Giveawayicon from '../../assets/images/icons/giveaways.svg';
import Benefits from '../../assets/images/icons/Benefits.svg';
import Events from '../../assets/images/icons/Events.svg';
import Memberships from '../../assets/images/icons/Memberships.svg';
import Ride24 from '../../assets/images/icons/Ride24.svg';
import './Giveaways.scss';

function Giveaways() {
  return (
    <div className="container-fluid bg-black">
      <div className="container p-none" style={{ width: "90%" }}>
        <div className="row py-600">

          {/* Hidden from home page tiles
          <div className="col-12 col-lg-3 p-150">
            <Link to="/Giveaway" className="home-tile-link">
              <div className="boxes h-full py-500 background-size-cover background-positon-center giveaways-bg-image">
                <img src={Giveawayicon} alt="" />
                <h1>Giveaways</h1>
                <p> See all our current Giveaways.</p>
              </div>
            </Link>
          </div>
          */}

          <div className="col-12 col-lg-3 p-150">
            <Link to="/Offers" className="home-tile-link">
              <div className="boxes h-full py-500  background-size-cover background-positon-center benefits-bg-image">
                <img src={Benefits} alt="" />
                <h1>Benefits</h1>
                <p>Get access to member only benefits from our partner businesses. <br /></p>
              </div>
            </Link>
          </div>

          <div className="col-12 col-lg-3 p-150">
            <Link to="/Events" className="home-tile-link">
              <div className="boxes h-full py-500  background-size-cover background-positon-center events-bg-image">
                <img src={Events} alt="" />
                <h1>Events</h1>
                <p> From exclusive showroom events to vibrant auto shows and thrilling track days, we host the most diverse range of automotive events </p>
              </div>
            </Link>
          </div>

          <div className="col-12 col-lg-3 p-150">
            <Link to="/Plans" className="home-tile-link">
              <div className="boxes h-full py-500 background-size-cover background-positon-center memberships-bg-image">
                <img src={Memberships} alt="" />
                <h1>Memberships</h1>
                <p>Choose from various subscription plans that suits you. <br /> </p>
              </div>
            </Link>
          </div>

          <div className="col-12 col-lg-3 p-150">
            <Link to="/ride-24" className="home-tile-link">
              <div className="boxes h-full py-500 background-size-cover background-positon-center ride24-bg-image">
                <img src={Ride24} alt="" />
                <h1>Ride24</h1>
                <p>Create your own rides, discover rides around you and connect with people who share your passion for the road.</p>
              </div>
            </Link>
          </div>


        </div>
      </div>
    </div>
  );
}

export default Giveaways;
